export enum ERequestStatus {
  INITIAL = 'INITIAL',
  LOADING = 'LOADING',
  FAILURE = 'FAILURE',
  LOADED = 'LOADED',
}
